import React from 'react';
import PropTypes from 'prop-types';

import TranslationFormattedMessage from 'utils/TranslationFormattedMessage';

const FourSightMatchTickerCard = ({
  isLive,
  statusLabel,
  currentSet,
  hasOdds,
  competitors,
}) => {
  const getSetResultClass = (rowIndex, setIndex, setValue) => {
    const parsedSetValue = Number(setValue);
    const rivalValue = Number(competitors[rowIndex === 0 ? 1 : 0]?.sets?.[setIndex]);

    if (!Number.isFinite(parsedSetValue) || !Number.isFinite(rivalValue)) {
      return 'card__set-value--regular';
    }

    if (parsedSetValue > rivalValue) {
      return 'card__set-value--won';
    }

    return 'card__set-value--lost';
  };

  const hasVisibleCurrentSet = Number(currentSet) > 0;

  return (
    <div className='card'>
      <div className='card__header'>
        <span className={`card__status ${isLive ? 'card__status--live' : 'card__status--default'}`}>{statusLabel}</span>
        {hasVisibleCurrentSet && <span className='card__phase uppercase'><TranslationFormattedMessage id='t_footer_match_tickers_set' />{` ${currentSet}`}</span>}
      </div>

      <div className='card__table'>
        {competitors.map((competitor, rowIndex) => (
          <div
            key={`${competitor.name}-${rowIndex}`}
            className='card__row'
          >
            <span className='card__name'>{competitor.name}</span>

            <div className='card__sets'>
              {(competitor.sets || []).map((setValue, setIndex) => (
                <span
                  key={`${competitor.name}-set-${setIndex}`}
                  className={`card__set-value ${getSetResultClass(rowIndex, setIndex, setValue)}`}
                >
                  {setValue}
                </span>
              ))}
            </div>

            <span
              className={`card__odds${hasOdds ? '' : ' card__odds--empty'}`}
              aria-hidden={!hasOdds}
            >
              {hasOdds ? competitor.odds : ''}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

FourSightMatchTickerCard.propTypes = {
  isLive: PropTypes.bool.isRequired,
  statusLabel: PropTypes.string,
  currentSet: PropTypes.string,
  hasOdds: PropTypes.bool,
  competitors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      sets: PropTypes.arrayOf(PropTypes.string),
      odds: PropTypes.string,
    }),
  ),
};

FourSightMatchTickerCard.defaultProps = {
  statusLabel: '',
  currentSet: '',
  hasOdds: false,
  competitors: [],
};

export default FourSightMatchTickerCard;
